import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25eccb1b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-value"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0,
  class: "name"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "sku-asin"
};
const _hoisted_6 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_annoncement_icon = _resolveComponent("annoncement-icon");
  const _component_hoverable_image = _resolveComponent("hoverable-image");
  const _component_list_marketplace_value = _resolveComponent("list-marketplace-value");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_hug_value = _resolveComponent("hug-value");
  return _openBlock(), _createBlock(_component_hug_value, {
    loading: $props.loading,
    align: $props.align,
    styles: {
      width: '100%',
      ...$props.styles
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$options.sponsored ? (_openBlock(), _createBlock(_component_annoncement_icon, {
      key: 0
    })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_list_marketplace_value, {
      list: $props.value?.image_channels,
      ref: "listMarketplaceValue"
    }, {
      "button-content": _withCtx(({
        shown
      }) => [_createVNode(_component_hoverable_image, {
        onClick: $options.handleClick,
        image: $props.value?.image,
        active: shown
      }, null, 8, ["onClick", "image", "active"])]),
      _: 1
    }, 8, ["list"])])), _createVNode(_component_flex_column, {
      classes: "product",
      gap: 2,
      styles: {
        width: '100%',
        padding: 0,
        overflow: 'hidden'
      }
    }, {
      default: _withCtx(() => [$options.sponsored ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Sponsored Brands Advertising Campaign")) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_wrap_with_popover, {
        width: "495px",
        customClass: "product-value-popover"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString($props.value.name), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString($options.productName), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_flex_row, {
        gap: 4,
        styles: {
          width: 'fit-content',
          height: 'fit-content',
          alignItems: 'flex-start'
        }
      }, {
        default: _withCtx(() => [$options.sku ? (_openBlock(), _createBlock(_component_wrap_with_copy, {
          key: 0,
          class: "sku"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($options.sku), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $options.sku ? (_openBlock(), _createElementBlock("div", _hoisted_6, "-")) : _createCommentVNode("", true), _createVNode(_component_wrap_with_copy, null, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($options.asin), 1)]),
          _: 1
        })]),
        _: 1
      })]), _ctx.$slots['badge'] ? _renderSlot(_ctx.$slots, "badge", {
        key: 0
      }, undefined, true) : _createCommentVNode("", true)], 64))]),
      _: 3
    })])]),
    _: 3
  }, 8, ["loading", "align", "styles"]);
}